/** Incident task status values. Kokomo treats 0 as open and 3 as closed. */
export const TASK_STATUS_OPEN = 0;
export const TASK_STATUS_DONE = 3;
/** Stored on task updatedInfo until External PUT /IncidentTasks exists. */
export const TASK_DONE_MARKER = '###Task Done###';
const DONE_MARKER_RE = /^###\s*Task Done\s*###\s*(?:\r?\n)*/i;
export const FALLBACK_TASK_STATUS_LABELS = {
    0: 'Open',
    1: 'Opened',
    2: 'Active',
    3: 'Done',
};
export function referralTaskStatusLabel(status) {
    return FALLBACK_TASK_STATUS_LABELS[status] ?? `Status ${status}`;
}
export function isClosedTaskStatus(status) {
    return status === TASK_STATUS_DONE;
}
export function isTaskDoneDescription(description) {
    return DONE_MARKER_RE.test((description ?? '').trim());
}
export function parseTaskUpdateDescription(description) {
    const raw = description ?? '';
    const match = raw.match(DONE_MARKER_RE);
    if (!match) {
        return { done: false, body: raw.trim() };
    }
    return { done: true, body: raw.slice(match[0].length).trim() };
}
export function taskDoneUpdateDescription(note = 'Marked as done.') {
    return `${TASK_DONE_MARKER}\n\n${note.trim()}`;
}
export function isReferralTaskDone(task) {
    if (isClosedTaskStatus(task.status))
        return true;
    return (task.updatedInfos ?? []).some((info) => isTaskDoneDescription(info.description));
}
